import Link from 'next/link';
import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
interface IMciGift {
  code: string;
}
const MciGift: FC<IMciGift> = ({
  code
}) => {
  return <>
      <div className="mb-8 text-center text-lg font-bold text-blueFive">
        <div>جایزه‌ی خرید این اشتراک، یه سیم‌کارت رایگان همراه اوله که با کد زیر می‌تونی دریافتش کنی:</div>
        <div className="my-2 font-mono text-3xl text-red-600">{code}</div>
      </div>
      <Button href={`https://campaign.ino.school/voch?c=${code}`} as={Link} target="_blank" variant="shadow" color="orange" className="mb-4 w-full" radius="circle" size="large" bold data-sentry-element="Button" data-sentry-source-file="MciGift.tsx">
        دریافت سیم‌کارت رایگان همراه اول
      </Button>
    </>;
};
export default MciGift;